import React, { useState } from "react";
import StoreAddressTab from "./address-tab/address-tab";
import TabsComponent from "../helper-components/tabs-component";
import StorePersonalTab from "./personal-details/personal-details";
import StoreFirmTab from "./firm-details-tab/firm-tab";
import StoreAgreementTab from "./store-agreement/store-agreement";
import StorePaymentTab from "./payment-tab/payment-tab";
import StoreDrugTab from "./drug-license-tab/drug-license-tab";
import StoreLOITab from "./loi-tab/loi-tab";

const StoreCreateViewEdit = ({
  storeData,
  setStoreData,
  store,
  permissionFn = () => {},
  disabled = false,
}) => {
  const [currentTab, setCurrentTab] = useState("Store Details");
  const [id, setId] = useState(store?.store_id);
  // An approved payment locks Store Details, Personal Details, Firm Details and
  // LOI it was approved against; declining the payment unlocks them again.
  const paymentApproved = !!storeData?.payment?.is_francise_fee_approved;

  // Steps finished on this screen. They win over the record loaded from
  // /store/getById, which only refreshes on reload.
  const [progress, setProgress] = useState({});
  const onProgress = (update) =>
    setProgress((prev) => ({ ...prev, ...update }));
  const isDone = (key) => !!(progress[key] ?? store?.[key]);

  // Each tab opens only once the step before it is done, in this order.
  const unlocked = { "Store Details": true };
  unlocked["Personal Details"] = isDone("is_approve_location");
  unlocked["Firm Details"] = unlocked["Personal Details"];
  unlocked["LOI"] =
    unlocked["Personal Details"] &&
    isDone("is_peronal_details_tab_completed") &&
    isDone("is_firm_details_tab_completed");
  unlocked["Payment"] = unlocked["LOI"] && isDone("is_loi_approved");
  unlocked["Drug License"] =
    unlocked["Payment"] && isDone("is_francise_fee_approved");
  unlocked["Store Agreement"] =
    unlocked["Drug License"] && isDone("is_approve_dl");
  const lockedTabs = itemTabs.filter((tab) => !unlocked[tab]);

  return (
    <>
      <TabsComponent
        handleClickfn={(item) => {
          setCurrentTab(item);
        }}
        itemTabs={itemTabs}
        setCurrentTab={setCurrentTab}
        currentTab={currentTab}
        disabledTabs={lockedTabs}
      />
      {currentTab === "Store Details" && (
        <StoreAddressTab
          permissionFn={permissionFn}
          disabled={disabled || paymentApproved}
          id={id}
          initialValue={storeData?.address}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "Personal Details" && (
        <StorePersonalTab
          disabled={disabled || paymentApproved}
          id={id}
          initialValue={storeData?.personal}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "Firm Details" && (
        <StoreFirmTab
          disabled={disabled || paymentApproved}
          id={id}
          initialValue={storeData?.firm}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "LOI" && (
        <StoreLOITab
          permissionFn={permissionFn}
          disabled={disabled || paymentApproved}
          id={id}
          initialValue={storeData?.loi}
          storeData={storeData}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "Store Agreement" && (
        <StoreAgreementTab
          permissionFn={permissionFn}
          disabled={disabled}
          id={id}
          initialValue={storeData?.agreement}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "Payment" && (
        <StorePaymentTab
          permissionFn={permissionFn}
          disabled={disabled}
          id={id}
          initialValue={storeData?.payment}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
      {currentTab === "Drug License" && (
        <StoreDrugTab
        permissionFn={permissionFn}
          disabled={disabled}
          id={id}
          initialValue={storeData?.drug}
          storeData={storeData}
          setId={setId}
          setStoreData={setStoreData}
          onProgress={onProgress}
        />
      )}
    </>
  );
};

export default StoreCreateViewEdit;

const itemTabs = [
  "Store Details",
  "Personal Details",
  "Firm Details",
  "LOI",
  "Payment",
  "Drug License",
  "Store Agreement",
];
